import React, { useEffect, useState } from "react"; // Keep React import for JSX
import { Droppable } from "react-beautiful-dnd";   // Remove DroppableProps type import
import PropTypes from 'prop-types';               // Import PropTypes for runtime checking (optional but recommended)

// Remove all type annotations (like : DroppableProps and : React.ReactNode)
const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {

    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {

      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []); 

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
};
 

StrictModeDroppable.propTypes = {
  children: PropTypes.node.isRequired, // React elements/nodes to render inside
  droppableId: PropTypes.string.isRequired,
};

export default StrictModeDroppable;